import {Component, Input, ComponentFactoryResolver, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {StrategiaPodsumowaniaUszkodzenia} from './strategia-podsumowania-uszkodzenia';
import {StrategiaDirective} from './strategia.directive';
import {StrategiaComponent} from './strategia.component';

@Component({
  selector: 'app-strategia-podsumowania-uszkodzen',
  templateUrl: './strategia-podsumowania-uszkodzen.component.html',
})
export class StrategiaPodsumowaniaUszkodzenComponent implements OnInit {

  @Input()
  strategiaPodsumowaniaUszkodzenia!: StrategiaPodsumowaniaUszkodzenia;

  @Input()
  zbiorUszkodzenPrzedmiotuId!: number

  @Input()
  zbiorUszkodzenId!: string

  @Output()
  usunUszkodzenieClick = new EventEmitter<{zbiorUszkodzenPrzedmiotowId: number, zbiorUszkodzenId: string, identyfikatorUszkodzenia: string}>();

  @ViewChild(StrategiaDirective, {static: true}) appStrategia!: StrategiaDirective;

  ngOnInit(): void {
    this.loadComponent();
  }

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
  }

  loadComponent(): void {
    const strategiaPodsumowaniaUszkodzenia = this.strategiaPodsumowaniaUszkodzenia;

    const viewContainerRef = this.appStrategia.viewContainerRef;
    viewContainerRef.clear();

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(strategiaPodsumowaniaUszkodzenia.slownikUszkodzen.strategiaPodsumowania);

    const componentRef = viewContainerRef.createComponent<StrategiaComponent>(componentFactory);
    componentRef.instance.slownikUszkodzen = strategiaPodsumowaniaUszkodzenia.slownikUszkodzen;
    componentRef.instance.uszkodzenie = strategiaPodsumowaniaUszkodzenia.uszkodzenie;
    const subscription = componentRef.instance.usunUszkodzenieClick.subscribe(event => this.usunUszkodzenieClick.emit(
    {zbiorUszkodzenPrzedmiotowId: this.zbiorUszkodzenPrzedmiotuId, zbiorUszkodzenId: this.zbiorUszkodzenId, identyfikatorUszkodzenia: event.identyfikatorUszkodzenia}
    ));
    componentRef.onDestroy(() => { subscription.unsubscribe(); });
  }
}
